module.exports = __webpack_public_path__ + "static/how-bg-c704f73895d2fe9a2879b2df8ed7a303.jpg";